export default __webpack_public_path__ + "static/media/score.16e63f16.svg";